import { z } from 'zod';
import { BASE_SCHEMAS, SCHEMAS } from './base';

export const userProfileSchema = z.object({
  displayName: z.string().min(1, 'Display name is required').max(100),
});

export const personalInfoSchema = z.object({
  displayName: SCHEMAS.userDisplayName,
  email: BASE_SCHEMAS.email('Personal Email'),
  phoneNumber: SCHEMAS.authPhoneNumber.optional(),
  phoneCode: SCHEMAS.authPhoneCode.optional(),
});

export type UserProfileData = z.infer<typeof userProfileSchema>;
export type PersonalInfoData = z.infer<typeof personalInfoSchema>;
